import React, { Component, ErrorInfo, ReactNode } from 'react';

interface PreviewErrorBoundaryProps {
  name: string;
  data: unknown;
  message: ReactNode;
  children: ReactNode;
}

interface PreviewErrorBoundaryState {
  error: Error | null;
}

export const PreviewMessage = ({ children }: { children: ReactNode }) => (
  <div style={{ border: '1px dashed #c00', padding: '16px' }}>{children}</div>
);

class PreviewErrorBoundary extends Component<
  PreviewErrorBoundaryProps,
  PreviewErrorBoundaryState
> {
  constructor(props: PreviewErrorBoundaryProps) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error): PreviewErrorBoundaryState {
    return { error };
  }

  componentDidUpdate(previousProps: PreviewErrorBoundaryProps): void {
    if (this.state.error && previousProps.data !== this.props.data) {
      this.setState({ error: null });
    }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    const { name, data } = this.props;

    console.error(
      `[live-preview] ${name} failed to render: ${error.message}`,
      data,
      errorInfo.componentStack
    );
  }

  render(): ReactNode {
    const { error } = this.state;
    const { message, children } = this.props;

    if (!error) return children;

    return (
      <PreviewMessage>
        {message}
        <br />
        <small>{error.message}</small>
      </PreviewMessage>
    );
  }
}

export default PreviewErrorBoundary;
